import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from '../constants';
import { LocalStorageStore } from '../utils/localstorage-store';
import { AccessToken } from './access-token';
export var TokenStore = /*#__PURE__*/function () {
  function TokenStore(clientId, store) {
    _classCallCheck(this, TokenStore);

    this.clientId = clientId;
    this.store = store || new LocalStorageStore();
    var accessTokenString = this.store.getItem(this.accessTokenKey);

    if (accessTokenString) {
      var parsedToken;

      try {
        parsedToken = AccessToken.fromString(accessTokenString);
      } finally {
        this.accessToken = parsedToken;
      }
    }
  }

  _createClass(TokenStore, [{
    key: "persistTokenResponse",
    value: function persistTokenResponse(response) {
      if (response.refreshToken) {
        this.store.setItem(this.refreshTokenKey, response.refreshToken);
      }

      var parsedToken = AccessToken.fromTokenResponse(response);
      this.store.setItem(this.accessTokenKey, parsedToken.toStorageString());
      this.accessToken = parsedToken;
    }
  }, {
    key: "invalidateCurrentToken",
    value: function invalidateCurrentToken() {
      this.accessToken = undefined;
      this.store.clearItem(this.accessTokenKey);
    }
  }, {
    key: "clear",
    value: function clear() {
      this.accessToken = undefined;
      this.store.clearItem(this.refreshTokenKey);
      this.store.clearItem(this.accessTokenKey);
    }
  }, {
    key: "currentToken",
    get: function get() {
      if (this.accessToken && !this.accessToken.expired) {
        return this.accessToken.token;
      }
    }
  }, {
    key: "refreshToken",
    get: function get() {
      var token = this.store.getItem(this.refreshTokenKey);

      if (token) {
        return token;
      }
    }
  }, {
    key: "accessTokenKey",
    get: function get() {
      return "".concat(ACCESS_TOKEN_KEY, ".").concat(this.clientId);
    }
  }, {
    key: "refreshTokenKey",
    get: function get() {
      return "".concat(REFRESH_TOKEN_KEY, ".").concat(this.clientId);
    }
  }]);

  return TokenStore;
}();